/**
 * The icons the authentication screens use.
 *
 * Inline rather than fetched: the sign-in screen is the first thing an unauthenticated visitor sees,
 * and it renders complete without a second request. Shared across the pages so six of them cannot
 * drift into six slightly different drawings.
 */

export function UserIcon(): React.JSX.Element {
  return (
    <svg className="input__icon" viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21a8 8 0 0 1 16 0" />
    </svg>
  );
}

export function BuildingIcon(): React.JSX.Element {
  return (
    <svg className="input__icon" viewBox="0 0 24 24" aria-hidden="true">
      <rect x="4" y="3" width="16" height="18" rx="2" />
      <path d="M9 8h2M13 8h2M9 12h2M13 12h2M10 21v-4h4v4" />
    </svg>
  );
}

export function MailIcon(): React.JSX.Element {
  return (
    <svg className="input__icon" viewBox="0 0 24 24" aria-hidden="true">
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m3 7 9 6 9-6" />
    </svg>
  );
}

export function LockIcon(): React.JSX.Element {
  return (
    <svg className="input__icon" viewBox="0 0 24 24" aria-hidden="true">
      <rect x="4" y="10" width="16" height="11" rx="2" />
      <path d="M8 10V7a4 4 0 0 1 8 0v3" />
    </svg>
  );
}

export function EyeIcon({ crossed }: { crossed: boolean }): React.JSX.Element {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6Z" />
      <circle cx="12" cy="12" r="3" />
      {crossed && <path d="m4 20 16-16" />}
    </svg>
  );
}

export function ArrowIcon(): React.JSX.Element {
  return (
    <svg className="button__arrow" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M5 12h14" />
      <path d="m13 6 6 6-6 6" />
    </svg>
  );
}

export function CheckIcon(): React.JSX.Element {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="m5 13 4 4L19 7" />
    </svg>
  );
}

/** Used where the action is "send me a link" rather than "sign me in". */
export function LinkIcon(): React.JSX.Element {
  return (
    <svg className="button__arrow" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1" />
      <path d="M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1" />
    </svg>
  );
}

/** Shown while a link is being exchanged for a session. */
export function SpinnerIcon(): React.JSX.Element {
  return (
    <svg className="auth__spinner" viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="9" opacity="0.25" />
      <path d="M21 12a9 9 0 0 0-9-9" />
    </svg>
  );
}

/** The state where a link could not be used. */
export function AlertIcon(): React.JSX.Element {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 3 2 20h20L12 3Z" />
      <path d="M12 10v4" />
      <path d="M12 17h.01" />
    </svg>
  );
}
